import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Preload home page chunk immediately — starts fetching before React mounts,
// so when lazy(() => import(...)) fires, the module is already in-flight or cached.
import('@/pages/home/page')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
